import { Injectable } from '@angular/core';
import { Animation } from '@ionic/angular';
import { fadeAnimation, slideAnimation, noAnimation, slideInvertedAnimation } from '../animations';

@Injectable({
  providedIn: 'root'
})
export class AnimationService {
  private animationType: string = 'instantOpacitySlide';
  public animationSpeed: number = 200;

  setAnimationType(type: string) {
    this.animationType = type;
  }

  getAnimationType(): string {
    return this.animationType;
  }

  getAnimation(): (baseEl: any, opts?: any) => Animation {
    switch (this.animationType) {
      case 'fadeAnimation':
        return (baseEl: any, opts?: any) => fadeAnimation(baseEl, opts, this.animationSpeed);
      case 'slideAnimation':
        return (baseEl: any, opts?: any) => slideAnimation(baseEl, opts, this.animationSpeed);
      case 'slideInvertedAnimation':
        return (baseEl: any, opts?: any) => slideInvertedAnimation(baseEl, opts, this.animationSpeed);
      case 'noAnimation':
        return noAnimation;
      default:
        return (baseEl: any, opts?: any) => slideAnimation(baseEl, opts, this.animationSpeed);
    }
  }
}